import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { AppConfigService } from './config/app-config.service'
import { AppConfig } from './config/app-config';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegistrationComponent } from './user/registration/registration.component';
import { LoginComponent } from './user/login/login.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { UserService } from './services/user.service';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { ChangePassComponet } from './user/changePass.component';
import { ActivationComponet } from './activation/activation.component';
import { CountriesDataComponent } from './countries/countriesData.component';
import { AuditLogComponent } from './auditLog/auditLog.component';
import { CountriesAuditLogsComponent } from './auditLog/countriesAuditLogs/countriesAuditLogs.component';
import { ActivatorAuditLogsComponent } from './auditLog/activatorAuditLogs/activatorAuditLogs.component';
import { CryptComponet } from './crypt/crypto.component';
import { CountriesDataService } from './services/countriesData.service';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function initializerFn(appConfigService: AppConfigService) {
    return () => { return appConfigService.load(); };

}

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent, 
        RegistrationComponent,
        LoginComponent,
        ChangePassComponet,
        ActivationComponet,
        CountriesDataComponent,
        AuditLogComponent,
        CountriesAuditLogsComponent,
        ActivatorAuditLogsComponent,
        CryptComponet
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AutocompleteLibModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgSelectModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ToastrModule.forRoot({
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false
        }),
        NgxSpinnerModule,
        MatTableModule,
        MatIconModule,
        MatFormFieldModule,
        MatDialogModule,
    ],
    providers: [
        UserService,
        CountriesDataService
        , {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: AppConfig,
            deps: [HttpClient],
            useExisting: AppConfigService
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [AppConfigService],
            useFactory: initializerFn
        }],
    bootstrap: [AppComponent],
    exports: [MatAutocompleteModule]

})
export class AppModule { }
